<template>
  <div class="node-complete-action">
    <button class="button basic" @click="onClickButton">
      <slot>
        <AppIcon name="task_alt" :color="iconColor" :size="size" />
      </slot>
    </button>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';
import AppIcon from '@/app/components/app-icon';

export default defineComponent({
  name: 'NodeCompleteAction',

  /**
   * 属性
   */
  props: {
    node: Object,
    size: String,
  },

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    completed() {
      return !!parseInt(this.node.completed, 10);
    },

    iconColor() {
      if (this.completed) {
        return 'var(--primary-color)';
      }

      return null;
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapActions({
      createComplete: 'complete/create/createComplete',
      destroyComplete: 'complete/destroy/deleteComplete',
      pushMessage: 'notification/pushMessage',
    }),

    onClickButton() {
      try {
        if (this.completed) {
          this.destroyComplete({ nodeId: this.node.id });
        } else {
          this.createComplete({ nodeId: this.node.id });
        }
      } catch (error) {
        this.pushMessage({ content: '暂时无法处理 🌋' });
      }
    },
  },

  /**
   * 使用组件
   */
  components: {
    AppIcon,
  },
});
</script>

<style scoped>
@import './styles/node-complete-action.css';
</style>
